import { render, staticRenderFns } from "./ReportEmployeesTable.vue?vue&type=template&id=87680c1c&"
import script from "./ReportEmployeesTable.vue?vue&type=script&lang=js&"
export * from "./ReportEmployeesTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportEmployeesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
